var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.34277 5.49599C3.4846 5.58246 3.63507 5.66548 3.7942 5.74503C4.9763 6.2972 6.25329 6.61773 7.55606 6.68929V5.88511C6.57092 5.80807 5.61117 5.53464 4.73336 5.08093L3.34277 5.49599Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.41358 3.37024C3.41879 3.68378 3.52425 3.98741 3.71453 4.23668L2.30837 4.64656C1.9841 4.29963 1.80371 3.84251 1.80371 3.36765C1.80371 2.89279 1.9841 2.43567 2.30837 2.08875L3.69377 2.50381C3.5109 2.75563 3.41279 3.05904 3.41358 3.37024Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.724 1.25079C13.5822 1.16432 13.4317 1.08131 13.2726 1.00176C12.0905 0.44959 10.8135 0.129055 9.51074 0.0574951V0.861675C10.4959 0.938718 11.4556 1.21215 12.3334 1.66585L13.724 1.25079Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.242 3.37153C15.2408 3.54768 15.2128 3.72264 15.159 3.89035C15.0757 4.16618 14.9401 4.42337 14.7594 4.64784L13.374 4.23278C13.5702 3.98658 13.677 3.68112 13.677 3.36634C13.677 3.05156 13.5702 2.74609 13.374 2.4999L14.7594 2.08484C15.0678 2.44294 15.2388 2.89898 15.242 3.37153Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.52051 5.88511V6.68929C10.8233 6.61773 12.1003 6.2972 13.2824 5.74503C13.4415 5.66548 13.592 5.58246 13.7338 5.49599L12.3484 5.08093C11.469 5.5353 10.5074 5.80875 9.52051 5.88511Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.34277 1.24817L4.72818 1.66323C5.60598 1.20952 6.56573 0.936094 7.55087 0.859051V0.0496826C6.2481 0.121242 4.97111 0.441778 3.78901 0.993946C3.62989 1.07696 3.48114 1.1617 3.34277 1.24817Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.53244 5.49937C10.8852 5.49937 12.7924 4.54699 12.7924 3.37218C12.7924 2.19737 10.8852 1.245 8.53244 1.245C6.17972 1.245 4.27246 2.19737 4.27246 3.37218C4.27246 4.54699 6.17972 5.49937 8.53244 5.49937Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.3164 4.78481C16.3268 5.1372 16.2741 5.48862 16.1608 5.82246C15.9721 6.3329 15.6965 6.80684 15.3461 7.22329C15.206 7.39969 15.0452 7.58647 14.8584 7.78881V6.05074C15.1191 5.7628 15.3296 5.43307 15.4811 5.07535C15.626 4.73226 15.7001 4.36344 15.699 3.991C15.699 3.95469 15.699 3.91318 15.699 3.87686C15.7383 3.70676 15.7574 3.53262 15.7561 3.35803C15.7561 3.35803 15.7561 3.31653 15.7561 3.29578C16.1162 3.70839 16.3152 4.23716 16.3164 4.78481Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.22783 6.05086V7.77336C2.04104 7.57621 1.88018 7.38943 1.74009 7.20784C1.38983 6.79133 1.11423 6.31741 0.925451 5.80701C0.812338 5.47312 0.759626 5.12175 0.769788 4.76936C0.785412 4.23662 0.987386 3.72622 1.34055 3.32703C1.34055 3.32703 1.34055 3.36853 1.34055 3.38929C1.33931 3.56386 1.35846 3.73798 1.39763 3.90811C1.39763 3.94443 1.39763 3.98594 1.39763 4.02225C1.3943 4.3949 1.46851 4.76417 1.61556 5.1066C1.76667 5.45269 1.97351 5.77168 2.22783 6.05086Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M9.53022 9.18299C10.9677 9.10975 12.3837 8.80309 13.7227 8.27505V6.62C12.4097 7.27287 10.9785 7.65403 9.51465 7.74066L9.53022 9.18299Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.55606 9.18299C6.11152 9.11199 4.68832 8.80529 3.34277 8.27505V6.62C4.65577 7.27287 6.08704 7.65403 7.55087 7.74066L7.55606 9.18299Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M16.3164 7.24055C16.3164 7.84238 16.249 8.73995 14.8584 10.2238V8.99418L15.1749 8.65694C15.6234 8.19156 16.0073 7.66806 16.3164 7.10046C16.3164 7.16272 16.3164 7.20423 16.3164 7.24055Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.22782 8.98777V10.2174C0.837232 8.73354 0.749023 7.83597 0.749023 7.23414C0.749023 7.19782 0.749023 7.15631 0.749023 7.12C1.05812 7.68759 1.44206 8.2111 1.89055 8.67647L2.22782 8.98777Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M13.7228 9.33875V10.7344C12.3829 11.2572 10.9669 11.5586 9.53027 11.6268V10.2104H9.57178C10.992 10.1347 12.3921 9.84069 13.7228 9.33875Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M7.55606 10.2104V11.6268C6.11238 11.5608 4.6892 11.2594 3.34277 10.7344V9.33875C4.68335 9.84383 6.09418 10.1379 7.52492 10.2104H7.55606Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M16.3164 9.70539C16.3164 10.3072 16.249 11.2048 14.8584 12.6886V11.459L15.1749 11.1218C15.6234 10.6564 16.0073 10.1329 16.3164 9.56531C16.3164 9.62757 16.3164 9.66388 16.3164 9.70539Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M2.22782 11.4604V12.69C0.837232 11.2062 0.749023 10.3086 0.749023 9.70679C0.749023 9.67047 0.749023 9.62897 0.749023 9.59265C1.05812 10.1602 1.44206 10.6838 1.89055 11.1491L2.22782 11.4604Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M13.7227 11.7958V13.1759C12.3789 13.7056 10.9574 14.0123 9.51465 14.0838V12.657H9.57173C10.9914 12.5847 12.3915 12.2942 13.7227 11.7958Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M7.55606 12.657V14.089C6.11122 14.0164 4.68799 13.708 3.34277 13.1759V11.7958C4.68556 12.2978 6.09816 12.5884 7.53011 12.657H7.55606Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M16.3164 14.6468C16.3164 15.2486 16.249 16.1462 14.8584 17.63V16.4004L15.1749 16.0632C15.6234 15.5978 16.0073 15.0743 16.3164 14.5067C16.3164 14.569 16.3164 14.6105 16.3164 14.6468Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M2.22782 16.4018V17.6314C0.837232 16.1476 0.749023 15.2552 0.749023 14.6482C0.749023 14.6119 0.749023 14.5704 0.749023 14.5341C1.05812 15.1017 1.44206 15.6252 1.89055 16.0905L2.22782 16.4018Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M13.7227 16.745V18.1406C12.3789 18.6704 10.9574 18.9771 9.51465 19.0486V17.6166H9.57173C10.992 17.5409 12.392 17.2469 13.7227 16.745Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M7.55606 17.6205V19.0525C6.11151 18.9816 4.6883 18.6749 3.34277 18.1445V16.7489C4.68335 17.254 6.09418 17.548 7.52492 17.6205H7.55606Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M16.3164 12.1378C16.3164 12.7396 16.249 13.6372 14.8584 15.121V13.9121L15.1749 13.5749C15.6234 13.1095 16.0073 12.586 16.3164 12.0184C16.3164 12.0859 16.3164 12.1378 16.3164 12.1378Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M2.22782 13.9187V15.1535C0.837232 13.6645 0.749023 12.7721 0.749023 12.1443C0.749023 12.108 0.749023 12.0665 0.749023 12.0302C1.05812 12.5977 1.44206 13.1213 1.89055 13.5866L2.22782 13.9187Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M13.7227 14.2606V15.6563C12.3789 16.186 10.9574 16.4927 9.51465 16.5642V15.1322H9.57173C10.992 15.0566 12.392 14.7626 13.7227 14.2606Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M7.55606 15.1322V16.5642C6.11151 16.4933 4.6883 16.1866 3.34277 15.6563V14.2606C4.68335 14.7657 6.09418 15.0597 7.52492 15.1322H7.55606Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M19.9482 10.4413C20.0901 10.5278 20.2405 10.6108 20.3997 10.6903C21.5789 11.2394 22.8522 11.5582 24.1511 11.6294V10.8304C23.166 10.7534 22.2063 10.48 21.3285 10.0262L19.9482 10.4413Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M20.0139 8.31818C20.0191 8.63172 20.1246 8.93535 20.3149 9.18462L18.9295 9.59968C18.6052 9.25276 18.4248 8.79563 18.4248 8.32078C18.4248 7.84592 18.6052 7.38879 18.9295 7.04187L20.3149 7.45693C20.1256 7.70478 20.0202 8.00643 20.0139 8.31818Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M30.3256 6.19611C30.1838 6.10964 30.0333 6.02662 29.8742 5.94707C28.6921 5.3949 27.4151 5.07437 26.1123 5.00281V5.80699C27.0974 5.88403 28.0572 6.15746 28.935 6.61117L30.3256 6.19611Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M31.8474 8.31946C31.8463 8.49562 31.8183 8.67057 31.7644 8.83829C31.6818 9.11594 31.5461 9.37494 31.3649 9.60096L29.9795 9.1859C30.1757 8.93971 30.2825 8.63424 30.2825 8.31946C30.2825 8.00468 30.1757 7.69922 29.9795 7.45303L31.3649 7.03796C31.6721 7.39471 31.8431 7.84871 31.8474 8.31946Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M26.124 10.8278V11.6268C27.4268 11.5552 28.7038 11.2347 29.8859 10.6825C30.045 10.603 30.1955 10.52 30.3373 10.4335L28.9519 10.0184C28.0729 10.4746 27.1113 10.7498 26.124 10.8278Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M19.9482 6.19611L21.3336 6.61117C22.2114 6.15746 23.1712 5.88403 24.1563 5.80699V5.00281C22.8536 5.07437 21.5766 5.3949 20.3945 5.94707C20.2354 6.02662 20.0866 6.10964 19.9482 6.19611Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M25.136 10.4369C27.4887 10.4369 29.3959 9.48449 29.3959 8.30968C29.3959 7.13487 27.4887 6.1825 25.136 6.1825C22.7832 6.1825 20.876 7.13487 20.876 8.30968C20.876 9.48449 22.7832 10.4369 25.136 10.4369Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M32.9231 9.72749C32.9335 10.0799 32.8808 10.4313 32.7675 10.7651C32.5698 11.2679 32.2872 11.733 31.9321 12.14C31.792 12.3164 31.6311 12.5032 31.4443 12.7056V10.9882C31.7051 10.7003 31.9156 10.3706 32.067 10.0128C32.2119 9.66976 32.286 9.30094 32.2849 8.9285C32.2849 8.89219 32.2849 8.85068 32.2849 8.81436C32.3242 8.64426 32.3434 8.47012 32.342 8.29554C32.342 8.29554 32.342 8.25403 32.342 8.23328C32.7108 8.64421 32.9174 9.17537 32.9231 9.72749Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M18.8333 10.9895V12.712C18.6465 12.5149 18.4857 12.3281 18.3456 12.1465C17.9953 11.73 17.7197 11.2561 17.5309 10.7457C17.4178 10.4118 17.3651 10.0604 17.3753 9.70802C17.3823 9.16271 17.5849 8.63803 17.946 8.22937C17.946 8.22937 17.946 8.27088 17.946 8.29163C17.9448 8.4662 17.9639 8.64033 18.0031 8.81046C18.0031 8.84677 18.0031 8.88828 18.0031 8.9246C17.9998 9.29724 18.074 9.66651 18.221 10.0089C18.3686 10.3679 18.5756 10.6994 18.8333 10.9895Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M26.1318 14.1231C27.5691 14.0515 28.9851 13.7466 30.3244 13.2204V11.5653C29.0142 12.2072 27.5885 12.5794 26.1318 12.66V14.1231Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M24.1615 14.1231C22.7173 14.0538 21.2941 13.7488 19.9482 13.2204V11.5653C21.2647 12.2099 22.6978 12.5822 24.1615 12.66V14.1231Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M32.9219 12.1898C32.9219 12.7916 32.8545 13.6892 31.4639 15.173V13.9434L31.7804 13.6062C32.2289 13.1408 32.6128 12.6173 32.9219 12.0497C32.9219 12.1119 32.9219 12.1431 32.9219 12.1898Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M18.8333 13.9448V15.1744C17.4427 13.701 17.3545 12.793 17.3545 12.1912C17.3545 12.1549 17.3545 12.1133 17.3545 12.077C17.6636 12.6446 18.0475 13.1681 18.496 13.6335L18.8333 13.9448Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M30.3263 14.2802V15.6758C28.9824 16.2056 27.561 16.5123 26.1182 16.5837V15.157H26.1752C27.5957 15.0796 28.9958 14.7839 30.3263 14.2802Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M24.1615 15.157V16.5889C22.717 16.518 21.2938 16.2113 19.9482 15.681V14.2802C21.2888 14.7852 22.6996 15.0793 24.1304 15.1518L24.1615 15.157Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M32.9219 14.6468C32.9219 15.2486 32.8545 16.1462 31.4639 17.63V16.4004L31.7804 16.0632C32.2289 15.5978 32.6128 15.0743 32.9219 14.5067C32.9219 14.569 32.9219 14.6105 32.9219 14.6468Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M18.8333 16.4018V17.6314C17.4427 16.1476 17.3545 15.2552 17.3545 14.6482C17.3545 14.6119 17.3545 14.5704 17.3545 14.5341C17.6636 15.1017 18.0475 15.6252 18.496 16.0905L18.8333 16.4018Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M30.3263 16.7489V18.1445C28.9824 18.6743 27.561 18.981 26.1182 19.0525V17.6205H26.1752C27.5955 17.5448 28.9956 17.2508 30.3263 16.7489Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M24.1615 17.6205V19.0525C22.717 18.9816 21.2938 18.6749 19.9482 18.1445V16.7489C21.2888 17.254 22.6996 17.548 24.1304 17.6205H24.1615Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoker);
export default __webpack_public_path__ + "static/media/poker.bf507e94c5aeac96ff6fe343e2448f8f.svg";
export { ForwardRef as ReactComponent };